module.exports = __webpack_public_path__ + "static/media/pets-step-info-fc.13a8c9f2.svg";